import { Lines, FadeUp } from "../site/Reveal";
import { Btn, SectionLabel } from "../site/Btn";
import { StoneCard } from "../site/StoneCard";
import { useLang } from "../../i18n/lang";
import { useMeta, useStones } from "../../lib/queries";

const LAYOUT = [
  { col: "md:col-span-7", frame: "aspect-[4/5]" },
  { col: "md:col-span-4 md:col-start-9 md:mt-40", frame: "aspect-[3/4]" },
  { col: "md:col-span-4", frame: "aspect-[3/4]" },
  { col: "md:col-span-4 md:mt-24", frame: "aspect-[3/4]" },
  { col: "md:col-span-4 md:mt-48", frame: "aspect-[3/4]" },
];

export const Selection = () => {
  const { t, to } = useLang();
  const { data: stones = [] } = useStones(true);
  const { data: meta } = useMeta();
  const list = stones.filter((s) => s.availability !== "sold").slice(0, 5);
  return (
    <section className="px-6 sm:px-10 lg:px-14 py-28 sm:py-36" data-testid="selection-section">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-16 lg:mb-24">
        <div className="lg:col-span-7">
          <SectionLabel n={2}>{t.selection.label}</SectionLabel>
          <Lines lines={[t.selection.title]} className="f-serif font-light tracking-[-0.02em] leading-[1] text-5xl sm:text-6xl lg:text-7xl mt-10" />
        </div>
        <FadeUp className="lg:col-span-4 lg:col-start-9">
          <p className="text-lg leading-relaxed text-[#3A3A3A]">{t.selection.sub}</p>
        </FadeUp>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-x-8 gap-y-16">
        {list.map((s, i) => (
          <FadeUp key={s.id} className={LAYOUT[i].col} delay={(i % 3) * 0.08}>
            <StoneCard stone={s} cats={meta?.categories || []} frame={LAYOUT[i].frame} index={i} />
          </FadeUp>
        ))}
      </div>
      <div className="mt-20 lg:mt-28 flex justify-center">
        <Btn to={to("/stones")} variant="outline" testid="explore-all-stones">{t.common.exploreAll}</Btn>
      </div>
    </section>
  );
};
